import { createSvgIcon } from "@mui/material";

export default createSvgIcon(
  <svg
    width="19"
    height="19"
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.3 0.5C1.82261 0.5 1.36477 0.689642 1.02721 1.02721C0.689642 1.36477 0.5 1.82261 0.5 2.3V11.3H2.3V2.3H11.3V0.5H2.3ZM5.9 4.1C5.42261 4.1 4.96477 4.28964 4.62721 4.62721C4.28964 4.96477 4.1 5.42261 4.1 5.9V14.9H5.9V5.9H14.9V4.1H5.9ZM16.7 9.5V16.7H9.5V9.5H16.7ZM16.7 7.7H9.5C9.02261 7.7 8.56477 7.88964 8.22721 8.22721C7.88964 8.56477 7.7 9.02261 7.7 9.5V16.7C7.7 17.1774 7.88964 17.6352 8.22721 17.9728C8.56477 18.3104 9.02261 18.5 9.5 18.5H16.7C17.1774 18.5 17.6352 18.3104 17.9728 17.9728C18.3104 17.6352 18.5 17.1774 18.5 16.7V9.5C18.5 9.02261 18.3104 8.56477 17.9728 8.22721C17.6352 7.88964 17.1774 7.7 16.7 7.7Z"
      fill="#222A5C"
    />
  </svg>,
  "PersonalizedGifs"
);
